import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const addSectionTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  exit: assign<Context>({
    isReorderMode: false
  }),
  invoke: {
    src: "addSection",
    onDone: {
      target: "#StudyPlan.edit_plan.add_lesson",
      actions: assign((ctx, evt) => ({
        studyPlan: evt.data.plan,
        selectedSectionId:
          evt.data.plan.sections[evt.data.plan.sections.length - 1]?.id,
        expanded: [
          ...ctx.expanded,
          evt.data.plan.sections[evt.data.plan.sections.length - 1]?.id
        ]
      }))
    },
    onError: {
      target: "#StudyPlan.edit_plan.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("addSection", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
